import React from 'react';
import ReactDOM from 'react-dom';
import styles from './Drawer.module.css';

class Drawer extends React.Component {
  constructor(props) {
    super(props);
    this.handleKey = this.handleKey.bind(this);
  }

  componentDidMount()    { document.addEventListener('keydown', this.handleKey); }
  componentWillUnmount() { document.removeEventListener('keydown', this.handleKey); }

  handleKey(e) {
    if (e.key === 'Escape' && this.props.open) {
      this.props.onClose && this.props.onClose();
    }
  }

  render() {
    const { open, onClose, title, subtitle, width = '480px', children, footer, ico, icoStyle } = this.props;

    if (!open) return null;

    return ReactDOM.createPortal(
      <div className={styles.overlay}>
        <div className={styles.backdrop} onClick={onClose} />
        <div className={styles.panel} style={{ width }}>
          <div className={styles.header}>
            {ico && (
              <div className={styles.headerIco} style={icoStyle}>
                <span className="material-symbols-rounded" style={{ fontSize: 18 }}>{ico}</span>
              </div>
            )}
            <div className={styles.headerInfo}>
              <div className={styles.title}>{title}</div>
              {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
            </div>
            <button className={styles.closeBtn} onClick={onClose}>
              <span className="material-symbols-rounded" style={{ fontSize: 18 }}>close</span>
            </button>
          </div>
          <div className={styles.body}>{children}</div>
          {footer && <div className={styles.footer}>{footer}</div>}
        </div>
      </div>,
      document.body
    );
  }
}

export default Drawer;
